import { failed } from "../components/common/Toastify";

export const handlePatientClick = (data, navigate) => {
    localStorage.removeItem("lastActiveTab");
    const baseUrl = window.location.origin;
    const patientId = data?.id;
    // If there is no internal patient id, this record is sourced externally only.
    if (!patientId) {
        failed("Patient is sourced externally and does not exist in Florizel yet.");
        return;
    }
    const url = `${baseUrl}/app/patients-details?patientId=${patientId}`
    window.open(url, "_blank");
};